module.exports = __webpack_public_path__ + "static/media/dial_legend_consumption_in_package.dce39746.svg";